var Scale = function (a, b) {
    if (a === b) {
        return 1;
    } else {
        return a / b;
    }
}

export default Scale;